import { render, staticRenderFns } from "./ConsultaURLTickets.vue?vue&type=template&id=2ed6a60e&"
import script from "./ConsultaURLTickets.vue?vue&type=script&lang=js&"
export * from "./ConsultaURLTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports